// Campus photo for /colleges/duquesne-university: CC BY 4.0, by Alekjds, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADuquesne_University_-_College_Hall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/duquesne-university/; credited under the photo.
const photo = {
    "slug": "duquesne-university",
    "alt": "College Hall, home of the McAnulty College of Liberal Arts, on the Duquesne University campus in Pittsburgh, Pennsylvania",
    "src": "/colleges/duquesne-university/campus-1600.webp",
    "srcSmall": "/colleges/duquesne-university/campus-800.webp",
    "srcMid": "/colleges/duquesne-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/duquesne-university/og.jpg",
    "title": "Duquesne University - College Hall",
    "author": "Alekjds",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADuquesne_University_-_College_Hall.jpg",
    "read": "2026-10-01"
};

export default photo;
